import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IFeedbackMobApp, TError } from './types/FeedbackMobApp-interface'

const FeedbackMobAppState = (state: RootState): IFeedbackMobApp => state.feedbackMobApp

export const FormFields = createSelector(
    [FeedbackMobAppState],
    (state): IFeedbackMobApp => state,
)

export const isLoadingFeedbackMobApp = createSelector(
    [FeedbackMobAppState],
    (state): boolean => state.isLoading,
)


export const errorFeedbackMobApp = createSelector(
    [FeedbackMobAppState],
    (state): string => state.error,
)
export const errorCodeFeedbackMobApp = createSelector(
    [FeedbackMobAppState],
    (state): number => state.errorCode,
)

